<template lang="html">
  <span class="p-autocomplete p-component p-inputwrapper p-inputwrapper-filled">
    <!-- {{searchText}} -->
    <input
      v-model="searchText"
      class="p-autocomplete-input p-inputtext p-component"
      type="search"
      v-bind="inputAttrs"
      :class="inputAttrs.class || inputClass"
      :placeholder="inputAttrs.placeholder || placeholder"
      :disabled="inputAttrs.disabled || disabled"
      @blur="blur"
      @focus="focus"
      @input="inputChange"
      @keyup.enter="keyEnter"
      @keydown.tab="keyEnter"
      @keydown.up="keyUp"
      @keydown.down="keyDown"
    />
    <div v-if="show" class="p-autocomplete-panel p-component">
      <!-- <Button label="Submit" /> -->
      <ul class="p-autocomplete-items">
        <li
          v-for="(item, i) in internalItems"
          :key="i"
          class="p-autocomplete-item"
          @click="onClickItem(item)"
          @mouseover="cursor = i"
        >
          <!-- {{item.display_name}} -->
          <component
            :is="componentItem"
            :item="item"
            :search-text="searchText"
          />
        </li>
      </ul>
    </div>
  </span>
</template>

<script>
import Item from "./Item.vue";
import utils from "./utils.js";
export default {
  name: "VAutocomplete",
  props: {
    componentItem: { default: () => Item },
    minLen: { type: Number, default: utils.minLen },
    wait: { type: Number, default: utils.wait },
    value: null,
    getLabel: {
      type: Function,
      default: (item) => item,
    },
    items: Array,
    autoSelectOneItem: { type: Boolean, default: true },
    placeholder: String,
    inputClass: { type: String, default: "v-autocomplete-input" },
    disabled: { type: Boolean, default: false },
    inputAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    keepOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      searchText: "",
      showList: false,
      cursor: -1,
      internalItems: this.items || [],
    };
  },
  computed: {
    hasItems() {
      return !!this.internalItems.length;
    },
    show() {
      return (this.showList && this.hasItems) || this.keepOpen;
    },
  },
  watch: {
    items(newValue) {
      this.setItems(newValue);
      let item = utils.findItem(
        this.items,
        this.searchText,
        this.autoSelectOneItem
      );
      if (item) {
        this.onSelectItem(item);
        this.showList = false;
      }
    },
    value(newValue) {
      if (!this.isSelectedValue(newValue)) {
        this.onSelectItem(newValue);
        this.searchText = this.getLabel(newValue);
      }
    },
  },
  created() {
    utils.minLen = this.minLen;
    utils.wait = this.wait;
    this.onSelectItem(this.value);
  },
  methods: {
    inputChange() {
      this.showList = true;
      this.cursor = -1;
      this.onSelectItem(null, "inputChange");
      utils.callUpdateItems(this.searchText, this.updateItems);
      this.$emit("change", this.searchText);
    },
    updateItems() {
      this.$emit("update-items", this.searchText);
    },
    focus() {
      this.$emit("focus", this.searchText);
      this.showList = true;
    },
    blur() {
      this.$emit("blur", this.searchText);
      setTimeout(() => (this.showList = false), 200);
    },
    onClickItem(item) {
      this.onSelectItem(item);
      this.$emit("item-clicked", item);
    },
    onSelectItem(item) {
      if (item) {
        this.internalItems = [item];
        this.searchText = this.getLabel(item);
        this.$emit("item-selected", item);
      } else {
        this.setItems(this.items);
      }
      this.$emit("input", item);
    },
    setItems(items) {
      this.internalItems = items || [];
    },
    isSelectedValue(value) {
      return 1 == this.internalItems.length && value == this.internalItems[0];
    },
    keyUp() {
      if (this.cursor > -1) {
        this.cursor--;
        this.itemView(
          this.$el.getElementsByClassName("v-autocomplete-list-item")[
            this.cursor
          ]
        );
      }
    },
    keyDown() {
      if (this.cursor < this.internalItems.length) {
        this.cursor++;
        this.itemView(
          this.$el.getElementsByClassName("v-autocomplete-list-item")[
            this.cursor
          ]
        );
      }
    },
    itemView(item) {
      if (item && item.scrollIntoView) {
        item.scrollIntoView(false);
      }
    },
    keyEnter() {
      if (this.showList && this.internalItems[this.cursor]) {
        this.onSelectItem(this.internalItems[this.cursor]);
        this.showList = false;
      }
    },
  },
};
</script>

<style>
.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
  font-size: 1.5em;
  padding: 10px 15px;
  box-shadow: none;
  border: 1px solid #157977;
  width: calc(100% - 32px);
  outline: none;
  background-color: #eee;
}
.v-autocomplete-selected .v-autocomplete-input {
  color: green;
  background-color: #f2fff2;
}
.v-autocomplete-list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #157977;
}

.v-autocomplete-list-item {
  cursor: pointer;
  background-color: #fff;
  padding: 10px;
  border-bottom: 1px solid #157977;
  border-left: 1px solid #157977;
  border-right: 1px solid #157977;
}
</style>
